<script>
import WarningCard from "@/components/_Shared/Warnings/Card";
import Notice from "@/components/_Shared/Notices/Content";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    WarningCard,
    Notice
  },

  data() {
    return {
      cyclesWithPendingPayment: null,
      disabledRoutes: ["subscriptions", "checkout", "cycle-checkout"]
    };
  },

  computed: {
    ...mapState("user", ["user"]),
    title() {
      return `Olá ${this.user.first_name}, você tem pagamentos pendentes!`;
    }
  },

  methods: {
    isVisible() {
      return (
        this.cyclesWithPendingPayment &&
        this.cyclesWithPendingPayment.length &&
        !this.disabledRoutes.includes(this.$route.name)
      );
    },
    ...mapActions("cycles", ["searchWithPendingPayment"])
  },

  async mounted() {
    this.cyclesWithPendingPayment = await this.searchWithPendingPayment();
  }
};
</script>

<template>
  <warning-card v-if="isVisible()">
    <notice
      icon="/static/payment-error.svg"
      :title="title"
      subtitle="Verifique o histórico da(s) sua(s) assinatura(s) e efetue o pagamento para evitar cancelamento."
    >
      <router-link class="btn bg-pink-outline mt-15" :to="{name: 'subscriptions'}">ver minhas assinaturas</router-link>
    </notice>
  </warning-card>
</template>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Warnings/PendingCyclePayments.vue